import React, {useContext, useState} from 'react';
import CardCoverageFacility from './CardCoverageFacility';
import ContactIcon from '../../../assests/img/contact.svg?react';
import PhoneOutlineIcon from '../../../assests/img/phone-outline.svg?react';
import EmailIcon from '../../../assests/img/email.svg?react';
import MobileIcon from '../../../assests/img/mobile.svg?react';
import AddressIcon from '../../../assests/img/address.svg?react';
import VisitingCard from '../../../assests/img/visting-card.png?url';
import EditIcon from '../../../assests/img/edit.svg?react';
import classNames from 'classnames';
import Popup from './Popup';
import {UserContext} from '../context/userContext';
import {getUserPermisson} from '../functions/utils';
import '../../../assests/css/underwriter.scss';

export interface underwriterProps {
    data: {
        contact: {
            id: number,
            name: string,
            title: string,
            phone: string,
            mobile: string,
            department: string,
            email: string,
            address: string,
            submissionEmail: string,
        },
        coverage: {id: number, value: string},
        facilityTypes: {id: number, value: string}[]
    }[],
    selectedCoverageId: number,
    onSelectedId: (id: number) => void,
}

export interface contactType {
    id: number,
    name: string,
    title: string,
    phone: string,
    mobile: string,
    department: string,
    email: string,
    address: string,
    submissionEmail: string,
}

export default function Underwriter(props: underwriterProps) {

    const data = props.data? props.data: [];
    const [showPopup, setShowPopup] = useState(false);
    const {data: {permissions}} = useContext(UserContext);

    const handlePopup = (popup: 'show' | 'hide')=> setShowPopup(popup === 'show'? true: false);

    return (
        <>
        <Popup title='' show={showPopup} size='lg' onClose={()=> handlePopup('hide')}>
            <div className="add-edit-underwriter-container">
                <div className="underwriter-header-container">
                    <div className="underwriter-heading">Add underwriter</div>
                    <div></div>
                </div>
                <div className="add-edit-underwriter-content">
                    <div>Underwriter name</div>
                </div>
            </div>
        </Popup>
        <div className="underwriter-details-container">
            {data.map(({coverage, facilityTypes, contact}, index)=> {
            if (!contact.name) {
                return null;
            }
            return (
            <div className={classNames('underwriter-container', coverage.id === props.selectedCoverageId? 'selected': 'not-selected')}
                key={`ur-${contact.id}-${index}`}>
                <div className="underwriter-content">
                    <CardCoverageFacility edit={false} view="detail" coverage={coverage} facilityTypes={facilityTypes}/>
                </div>
                <div className="underwriter-contact-container">
                    <div>
                        <div className="card-contact-name">
                            <ContactIcon width={"18"} height={"18"}/>
                                {contact.name}
                            <span className="edit-icon">
                                {getUserPermisson(permissions, 'U')?<EditIcon width={16} height={16}
                                    onClick={()=>
                                        props.onSelectedId(contact.id)}/>: null}
                            </span>
                        </div>
                        <div className="card-contact-name">
                            <img className="card-title-img"
                                src={VisitingCard} alt='visting-card-img'
                                width={'18px'}/>
                            <div className="card-contact-name-type">
                                {contact.title}{contact.department?.length?
                                    `, ${contact.department}`: ''}
                            </div>
                        </div>
                    </div>
                    <div className="card-seperator underwriter"></div>
                    <div className="card-contact-details">
                        <div className="card-contact-phone underwriter">
                            <AddressIcon width={"16"} height={"16"}/>
                            {contact.address? contact.address: 'N/A'}
                        </div>
                        <div className="card-contact-phone underwriter">
                            <div>
                                <PhoneOutlineIcon width={"16"} height={"16"}/>
                                {contact.phone? contact.phone: 'N/A'}
                            </div>
                            <div>
                                <MobileIcon width={"16"} height={"16"}/>
                               {contact.mobile? contact.mobile: 'N/A'}
                            </div>
                        </div>
                        <div className="card-contact-phone underwriter">
                            <span> <EmailIcon width={"16"} height={"16"}/> </span>
                            <span>{contact.email? contact.email: 'N/A'}</span>
                        </div>
                        <div className="card-contact-phone underwriter">
                            <span> <EmailIcon width={"16"} height={"16"}/> </span>
                            <span>{contact.submissionEmail? contact.submissionEmail: 'N/A'}</span>
                        </div>
                    </div>
                </div>
            </div> );
            })}
        </div></>
    );

}